import React, { useEffect, useState } from 'react';
import { Panel, Breadcrumb, Nav } from 'rsuite';
import UserForm from './UserForm';
import { useTranslation } from 'react-i18next';

import UserPermissions from './UserPermissions';
import Access from './Access';
import { useAppSelector } from '@/config/hooks';
import AccessPriority from './AccessPriority';
import { fetchSetting } from '@/services/setting.service';

const User = () => {
  const [active, setActive] = useState('profile');

  const features = useAppSelector((state: any) => state.feature.data);
  const [withPriority, setWithPriority] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res: any = await fetchSetting('Homepage');
        console.log('res', res);
        setWithPriority(res?.configuration?.bookingWithPriority);
      } catch (e) {
        console.log('e', e);
      }
    };
    fetchData();
  }, []);

  const Navbar = ({ active, onSelect, ...props }) => {
    const { t } = useTranslation();

    return (
      <Nav {...props} activeKey={active} onSelect={onSelect} style={{ marginBottom: 50 }}>
        <Nav.Item eventKey="profile">{t("Profile")}</Nav.Item>
        {features?.find(item => item.name?.toLowerCase() == 'on site') && (
          <Nav.Item eventKey="accesses">{t('Zones Access')}</Nav.Item>
        )}
        {features?.find(item => item.name?.toLowerCase() == 'travel') && (
          <Nav.Item eventKey="permissions">{t('Travel permissions')}</Nav.Item>
        )}
      </Nav>
    );
  };
  const { t } = useTranslation();

  return (
    <Panel
      header={
        <>
          <h3 className="title">{t('Edit member')}</h3>{' '}
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('Home')}</Breadcrumb.Item>
            <Breadcrumb.Item href="/membersList">{t('Members')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('Details')} </Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <Panel bodyFill style={{ background: '#fff', padding: 20 }}>
        <Navbar appearance="tabs" active={active} onSelect={setActive} />

        {active == 'profile' ? (
          <UserForm />
        ) : active == 'accesses' && withPriority == true ? (
          <AccessPriority />
        ) : active == 'accesses' && !withPriority ? (
          <Access />
        ) : (
          <UserPermissions />
        )}
      </Panel>
    </Panel>
  );
};

export default User;
